import IconSearch from "@assets/tsx/icon/search";
import { Modal } from "@assets/tsx/modal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import { SearchControl } from "@assets/tsx/searchControl";
import React, { useEffect, useState } from "react";
import { useRouterPath } from "@ambiguous/useRouterPath";
import Ribbon from "@widgets/ribbon";
import { useLang } from "@ambiguous/useLang";
import { useI18n } from "@wordpress/react-i18n";
import RibbonSeparator from "@widgets/ribbon/ribbonSeparator";
export default function Search() {
    const { __ } = useI18n();
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [, setPath] = useRouterPath();
    const [lang] = useLang();
    useEffect(() => {
        if (open === false)
            setQuery('');
    }, [open]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "ltg-search", onClick: () => { setOpen(true); } },
            React.createElement("span", { className: "sr-only" }, __("Paieška", 'ltg-widgets')),
            React.createElement(IconSearch, null)),
        React.createElement(Modal, { open: open },
            React.createElement(OutsideAlerter, { className: "ltg-search-modal", callback: () => { setOpen(false); } },
                React.createElement("div", { className: "ltg-search-modal-content" },
                    React.createElement("div", { className: "ltg-search-modal-header" },
                        React.createElement("h1", { role: 'presentation' }, __("Paieška", 'ltg-widgets')),
                        React.createElement("button", { type: "button", className: "btn btn-white", onClick: () => { setOpen(false); } },
                            React.createElement("i", { className: "fas fa-times text-primary" }))),
                    React.createElement("div", { className: "ltg-search-modal-body" },
                        React.createElement("form", { onSubmit: (ev) => {
                                ev.preventDefault();
                                setPath(`/${(lang === null || lang === void 0 ? void 0 : lang.toLowerCase()) === 'lt' ? '' : lang === null || lang === void 0 ? void 0 : lang.toLowerCase()}?s=${encodeURIComponent(query)}`);
                                setOpen(false);
                            } },
                            React.createElement("div", { className: "ltg-search-modal-form-group" },
                                React.createElement(SearchControl, { value: query, onChange: setQuery, autofocus: true }),
                                React.createElement("button", { className: 'btn btn-black' }, __("Ieškoti", 'ltg-widgets'))))),
                    React.createElement("div", { className: "ribbon-wrap" }, THEME === 'museum' ?
                        React.createElement(RibbonSeparator, null)
                        : React.createElement(React.Fragment, null,
                            React.createElement(Ribbon, { side: "left", color: "primary" }),
                            React.createElement(Ribbon, { side: "right", color: "black" }))))))));
}
